export default function() {
  let desc = document.getElementById('desc');
  desc.className = 'text-center';
  desc.innerText = "I'm awakening in the new world.";
}



// WEBPACK FOOTER //
// ./js/awake.js